module.exports = __webpack_public_path__ + "img/Dantam Hair 45.6e0bf573.jpg";